// extracted by mini-css-extract-plugin
export default {"container":"Search_container__JDaLY","sidebarWrapper":"Search_sidebarWrapper__9FWUN","loaderWrapper":"Search_loaderWrapper__6LVB2"};